import { render, staticRenderFns } from "./BotFileMessage.vue?vue&type=template&id=d2eab836&scoped=true"
import script from "./BotFileMessage.vue?vue&type=script&lang=js"
export * from "./BotFileMessage.vue?vue&type=script&lang=js"
import style0 from "./BotFileMessage.vue?vue&type=style&index=0&id=d2eab836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2eab836",
  null
  
)

export default component.exports